import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { CenterContainer } from '@components/centerContainer';
import { LineTitle, TextMessage, LineContainer, EmailLink } from '@components/common';

export const ContactView = () => {
  const intl = useIntl();
  const serviceEmail = intl.formatMessage({
    id: 'contactView.serviceEmail',
    defaultMessage: 'customerservice@platformart.com',
  });
  const pressEmail = intl.formatMessage({ id: 'contactView.pressEmail', defaultMessage: 'press@platformart.com' });
  const imageEmail = intl.formatMessage({
    id: 'contactView.rightsEmail',
    defaultMessage: 'imagerights@platformart.com',
  });

  return (
    <CenterContainer>
      <LineTitle>
        <FormattedMessage id="contactView.title" defaultMessage="Contact:" />
      </LineTitle>
      <TextMessage>
        <FormattedMessage
          id="contactView.contact"
          defaultMessage="If you have a question, please read our FAQ or contact us at "
        />
        <EmailLink href={`mailto:${serviceEmail}`}>{serviceEmail}</EmailLink>
        <FormattedMessage id="contactView.respond" defaultMessage=". We'll respond to you as soon as possible." />
      </TextMessage>
      <LineContainer>
        <TextMessage>
          <FormattedMessage id="contactView.pressContact" defaultMessage="For press inquiries, please contact " />
          <EmailLink href={`mailto:${pressEmail}`}>{pressEmail}</EmailLink>
        </TextMessage>
      </LineContainer>
      <LineContainer>
        <TextMessage>
          <FormattedMessage id="contactView.imageContact" defaultMessage="For image inquiries, please contact " />
          <EmailLink href={`mailto:${imageEmail}`}>{imageEmail}</EmailLink>
        </TextMessage>
      </LineContainer>
    </CenterContainer>
  );
};
